import { Observable } from 'rxjs';

import { AutomixGainMetering, StereoAutomixGainMetering } from '@shure/shared/angular/data-access/system-api/models';
import {
	AudioMetering,
	ChannelMetering,
	StereoChannelMetering,
	BoostCutMetering,
	CompressorEngaged,
	LimiterEngaged,
	AudioGateOnMetering,
	AecErleMetering,
	DenoiserNoiseReduction,
	RfChannelMetering,
	MultiAntennaRfChannelMetering,
	ChannelAnalogStereoMetering
} from '@shure/shared/models';

export abstract class MeteringApiService {
	public abstract getAudioMetering$(coverageAreaId: string): Observable<AudioMetering>;

	public abstract getVirtualAudioMetering$(coverageAreaId: string): Observable<AudioMetering>;

	public abstract isChannelGatedOn$(channelId: string, isVirtual: boolean): Observable<boolean>;
	public abstract isCoverageAreaGatedOn$(coverageAreaId: string, isVirtual: boolean): Observable<boolean>;
	public abstract subscribeChannelMetering$(channelId: string, isVirtual: boolean): Observable<ChannelMetering>;
	public abstract subscribeChannelAnalogStereoMetering$(
		channelId: string,
		isVirtual: boolean
	): Observable<ChannelAnalogStereoMetering>;
	public abstract subscribeMatrixMixerOutputMetering$(
		channelId: string,
		isVirtual: boolean
	): Observable<ChannelMetering>;
	public abstract subscribeMatrixMixerInputMetering$(
		channelId: string,
		isVirtual: boolean
	): Observable<ChannelMetering>;
	public abstract subscribeStereoChannelMetering$(
		channelId: string,
		isVirtual: boolean
	): Observable<StereoChannelMetering>;
	public abstract subscribeMatrixMixerStereoInputMetering$(
		channelId: string,
		isVirtual: boolean
	): Observable<StereoChannelMetering>;
	public abstract subscribeBoostCutMetering$(channelId: string, isVirtual: boolean): Observable<BoostCutMetering>;
	public abstract subscribeCompressorEngaged$(channelId: string): Observable<CompressorEngaged>;
	public abstract subscribeLimiterEngaged$(channelId: string): Observable<LimiterEngaged>;
	public abstract subscribeAudioGateOnMetering$(
		channelId: string,
		isVirtual: boolean,
		updateRate?: number
	): Observable<AudioGateOnMetering>;
	public abstract subscribeCoverageAreaGateOnMetering$(
		coverageAreaId: string,
		isVirtual: boolean,
		updateRate?: number
	): Observable<AudioGateOnMetering>;
	public abstract subscribeAutomixGainMetering$(
		channelId: string,
		isVirtual: boolean
	): Observable<AutomixGainMetering>;
	public abstract subscribeStereoAutomixGainMetering$(
		channelId: string,
		isVirtual: boolean
	): Observable<StereoAutomixGainMetering>;
	public abstract subscribePostGateGainStereoMetering$(
		channelId: string,
		isVirtual: boolean
	): Observable<StereoChannelMetering>;
	public abstract subscribeAgcMetering$(channelId: string, isVirtual: boolean): Observable<ChannelMetering>;
	public abstract subscribeAecErleMetering$(channelId: string, isVirtual: boolean): Observable<AecErleMetering>;
	public abstract subscribeAecPostMetering$(channelId: string, isVirtual: boolean): Observable<ChannelMetering>;
	public abstract subscribeAutomixerInputMetering$(
		channelId: string,
		isVirtual: boolean
	): Observable<ChannelMetering>;
	public abstract subscribeDenoiserNRMetering$(
		channelId: string,
		isVirtual: boolean
	): Observable<DenoiserNoiseReduction>;
	public abstract subscribeRfChannelMetering$(channelId: string, isVirtual: boolean): Observable<RfChannelMetering>;
	public abstract subscribeMultiAntennaRfChannelMetering$(
		channelId: string,
		isVirtual: boolean
	): Observable<MultiAntennaRfChannelMetering>;
	public abstract subscribeBondedUsbChannelMetering$(
		leftChannelId: string,
		rightChannelId: string,
		isVirtual: boolean
	): Observable<StereoChannelMetering>;
}
